/*! @azure/msal-common v14.0.2 2023-08-18 */
'use strict';
/* eslint-disable header/header */
const name = "@azure/msal-common";
const version = "14.0.2";

export { name, version };
